import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Switch,
  Modal,
  Input,
  Form,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { FaSliders } from "react-icons/fa6";
import IMAGES from "../../../const/Image";
import { components, getRowClassName } from "../../../utils/utils";
import carRequest from "../CarRequest";
import userRequest from "../../UserManagement/UserRequest";
import { CarFilter } from "./CarFilter";

const { confirm } = Modal;

const initialFilter = {
  page: 1,
};

export const Cars = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredCars, setFilteredCars] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  // Fetch filtered car list
  const fetchCarFilterList = () => {
    setLoading(true);
    carRequest
      .carFilteredList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        setFilteredCars(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch cars.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCarFilterList();
  }, [filter]);

  // Fetch booking vendor list
  const fetchVendorList = () => {
    setLoading(true);
    userRequest
      .vendorList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData);
        setVendorList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch vendor list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchVendorList();
  }, []);

  // Handle search filter
  const handleFilter = () => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    setIsModalOpen(false);
  };

  // Handle pagination changes
  const handleChange = (pagination) => {
    setFilter({ ...filter, page: pagination?.current });
  };

  // Reset filters to initial state
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Columns configuration for the Table
  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Company Name",
      dataIndex: "make",
      key: "make",
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Chassis No",
      dataIndex: "vin",
      key: "vin",
    },
    {
      title: "Registration No",
      dataIndex: "licensePlate",
      key: "licensePlate",
    },
    {
      title: "Vendor Name",
      dataIndex: "ownerName",
      key: "ownerName",
    },
    {
      title: "Document",
      dataIndex: "fileName",
      key: "fileName",
      render: (text, record) => {
        return record.fileName?.trim() ? (
          <a href={record.fileName} target="_blank" rel="noopener noreferrer">
            View Document
          </a>
        ) : (
          text
        );
      }
    },
    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   width: 120,
    //   align: "center",
    //   render: (isActive, item) => (
    //     <Switch
    //       checked={isActive}
    //       checkedChildren="Active"
    //       unCheckedChildren="Inactive"
    //       //onChange={(checked) => handleStatusChange(checked, item)}
    //     />
    //   ),
    // },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Tooltip title="Edit Details">
    //         {/* <span
    //           className="action-icon-bg"
    //           onClick={() =>
    //             navigate(`/user-management/users/update/${record.staffId}`)
    //           }
    //         >
    //           <img src={IMAGES.EditIcon} />
    //         </span> */}
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
  ];

  // Handle status change (active/inactive)
  const handleStatusChange = (checked, item) => {
    if (!item.id) {
      notification.error({
        message: "User ID is required to update status.",
      });
      return;
    }
    // Uncomment and implement status change functionality if needed
    // confirm({
    //   title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this user?`,
    //   okText: "Yes",
    //   cancelText: "No",
    //   onOk() {
    //     setLoading(true);
    //     driverRequest.updateUserStatus({
    //       status: checked ? 1 : 0,
    //       userId: item.id,
    //     })
    //       .then((res) => {
    //         if (res && res.status === 200) {
    //           notification.success({
    //             message: "User updated successfully",
    //           });
    //           fetchUserFilterList();
    //         } else {
    //           notification.error({
    //             message: "Failed to update status",
    //           });
    //         }
    //       })
    //       .catch(() => {
    //         notification.error({
    //           message: "Failed to update status",
    //         });
    //       })
    //       .finally(() => {
    //         setLoading(false);
    //       });
    //   },
    // });
  };

  return (
    <>
      <div>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Car List</h1>
          </Col>
          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Button
                onClick={showModal}
                type="primary"
                className="addcity-btn"
              >
                <FaSliders />
              </Button>
              <Button
                onClick={resetFilters}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                Reset
              </Button>
              {/* <Button
                onClick={() => navigate("/user-management/user/add")}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button> */}
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredCars}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>
      <CarFilter
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        vendorList={vendorList}
      />
    </>
  );
};
